// elements/theming/global-style.ts
import { ASS } from "@adornis/ass/index";
import { ArrayBehaviorSubject } from "@adornis/base/rxjs-extension/reactives/array";
import { combineLatest, filter, switchMap } from "rxjs";
import { DesignSystem } from "./design";
var globalStyle = new ArrayBehaviorSubject([]);
var setGlobalStyle = (style) => {
  globalStyle.push(style);
  const styleNode = document.createElement("style");
  styleNode.innerHTML = "";
  document.head.appendChild(styleNode);
};
var headStyle;
combineLatest([
  globalStyle,
  DesignSystem.ready.pipe(
    filter(Boolean),
    switchMap(() => DesignSystem.currentTheme)
  )
]).subscribe(([styles]) => {
  if (!headStyle) {
    headStyle = document.createElement("style");
    document.head.appendChild(headStyle);
  }
  const stringStyles = styles.map((style) => ASS.makeSheet(style())).map((ass) => ass.toString()).join("\n\n");
  headStyle.textContent += `
${stringStyles}
`;
});
export {
  globalStyle,
  setGlobalStyle
};
